export default __webpack_public_path__ + "static/media/angelie3.4bf9abd5.jpg";